module.exports = __webpack_public_path__ + "static/model-off-image-4-3c1658dd5201d2e6323e43bc18300a61.jpg";